/* @flow */
import cx from 'classnames';
import Downshift from 'downshift';
import * as React from 'react';

import Button from 'components/Button.jsx';
import Icon from 'components/Icon.jsx';
import Input from 'components/Input.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';

import './InputTypeahead.scss';

type Props = {
  className?: string,
  defaultSelectedItem?: any,
  disabled?: boolean,
  entity?: string,
  inline?: boolean,
  items: Array<string>,
  loading?: boolean,
  noResults?: any,
  onChange?: Function,
  placeholder?: string,
  resultsAppend?: any,
  showDropdownButton?: boolean,
};

type State = {
  showAll: boolean,
};

class InputTypeahead extends React.Component<Props, State> {
  state = {
    showAll: false,
  };

  handleDownshiftStateChange = (changes: *) => {
    if (this.state.showAll && changes.isOpen === false) {
      this.setState({ showAll: false });
    }
  };

  render() {
    const {
      className,
      disabled,
      entity,
      inline,
      items,
      loading,
      noResults: propsNoResults,
      placeholder: propsPlaceholder,
      resultsAppend,
      showDropdownButton,
      ...others
    } = this.props;

    const { showAll } = this.state;

    const noResults = propsNoResults || (entity ? `No ${entity} found` : null);
    const placeholder = propsPlaceholder || (entity ? `Select ${entity}` : null);

    return (
      <Downshift
        {...others}
        onStateChange={this.handleDownshiftStateChange}
        render={({
          getInputProps,
          getItemProps,
          highlightedIndex,
          inputValue,
          isOpen,
          selectedItem,
          clearSelection,
          toggleMenu,
          openMenu,
        }) => {
          const matchingItems = items.filter(
            i => !inputValue || i.toLowerCase().includes(inputValue.toLowerCase()) || showAll
          );
          const isMatchingItems = matchingItems.length;
          const onChange = event => {
            if (event.target.value.length === 0) {
              clearSelection();
            }
          };
          const onDropdownButtonClick = () => {
            this.setState({ showAll: true });
            toggleMenu();
          };
          const dropdownButton = showDropdownButton ? (
            <Button
              aria-label="Open dropdown menu"
              level="icon"
              onClick={onDropdownButtonClick}
              disabled={disabled}>
              <Icon size="medium" name="arrow-shallow-down" color="koala" />
            </Button>
          ) : null;

          return (
            <div className={cx('InputTypeahead', inline && 'InputTypeahead--inline', className)}>
              <Input
                append={dropdownButton}
                {...getInputProps({
                  placeholder,
                  disabled,
                  onChange,
                })}
                onClick={openMenu}
              />
              {isOpen && (loading || isMatchingItems || noResults) ? (
                <div className="InputTypeahead-dropdown">
                  {loading && <LoadingIndicator align="center" height={24} size="small" />}
                  {isMatchingItems ? (
                    <div className="InputTypeahead-results">
                      {matchingItems.map((item, index) => (
                        <div
                          {...getItemProps({
                            className: cx(
                              'InputTypeahead-results-item',
                              highlightedIndex === index &&
                                'InputTypeahead-results-item--highlight',
                              selectedItem === index && 'InputTypeahead-results-item--active'
                            ),
                            item,
                          })}
                          key={item}>
                          {item}
                        </div>
                      ))}
                      {resultsAppend && (
                        <div className="InputTypeahead-results-item InputTypeahead-results-item--static">
                          {resultsAppend}
                        </div>
                      )}
                    </div>
                  ) : (
                    noResults
                  )}
                </div>
              ) : null}
            </div>
          );
        }}
      />
    );
  }
}

export default InputTypeahead;
